/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_ExpiredInputs */

const es_co2_error_invitation_expired = /** @type {(inputs: Error_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta invitación expiró.`)
};

/**

* @param {Error_Invitation_ExpiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_invitation_expired = /** @type {((inputs?: Error_Invitation_ExpiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_ExpiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_invitation_expired(inputs)
});